module.exports = new __parcel__URL__("space_elixir_storage_level_12.a5d025c0.png").toString();